import {onDomReady} from "./observer.js";


class Popup {
    constructor() {
        this.options = {
            popupTrigger: '[data-popup-trigger]',
            // popupClass: 'popup',
            dropboxOpenedClass: '_opened',
            popupOpenedClass: '_opened',
            popupNoir: '[data-popup-noir]', // to trigger close on click
            popupClose: '[data-popup-close]',
            popupPreopenedClass: '_preopened',
            popupPositioner: '[data-popup-positioner]',
            popupFocus: '[data-popup-focus]',
            margin: 12,
            offset: 10,
        };

        this.elements = {
            popupTrigger: document.querySelectorAll(this.options.popupTrigger),
        };

        this.init();
    }

    // popupTrigger - button for popup open event
    // popupWindows - target div to be opened

    init() {

        if (this.elements.popupTrigger) {
            const popupTriggerElements = this.elements.popupTrigger;
            popupTriggerElements.forEach((popupTriggerCurrent) => {

                popupTriggerCurrent.addEventListener('click', (event) => {


                    const triggerValueCurrent = popupTriggerCurrent.getAttribute('data-popup-trigger');
                    const popupWindowCurrent = document.querySelector(`[data-popup-window="${triggerValueCurrent}"]`);

                    if (popupWindowCurrent) {

                        const popupPositionerCurrent = popupWindowCurrent.querySelector(this.options.popupPositioner);
                        if (popupPositionerCurrent) {
                            this.setPosition(popupTriggerCurrent, popupPositionerCurrent);
                        }

                        popupTriggerCurrent.classList.toggle(this.options.dropboxOpenedClass);
                        popupWindowCurrent.classList.toggle(this.options.popupOpenedClass);

                        if (popupWindowCurrent.classList.contains(this.options.popupOpenedClass)) {
                            const onScrollHandler = function () {
                                popupTriggerCurrent.classList.remove(this.options.dropboxOpenedClass);
                                popupWindowCurrent.classList.remove(this.options.popupOpenedClass);

                                // Remove the event listener
                                window.removeEventListener('scroll', onScrollHandler);
                            }.bind(this);

                            // Attach the event listener
                            window.addEventListener('scroll', onScrollHandler);


                            const popupFocusCurrent = popupWindowCurrent.querySelector(this.options.popupFocus);
                            if (popupFocusCurrent) {
                                setTimeout(function () {
                                    popupFocusCurrent.focus();
                                    popupFocusCurrent.selectionStart = popupFocusCurrent.selectionEnd = popupFocusCurrent.value.length;
                                }, 500);
                            }
                        }

                        const popupWindowCurrentNoir = popupWindowCurrent.querySelector(this.options.popupNoir);
                        if (popupWindowCurrentNoir) {
                            popupWindowCurrentNoir.addEventListener('click', (event) => {
                                popupTriggerCurrent.classList.remove(this.options.dropboxOpenedClass);
                                popupWindowCurrent.classList.remove(this.options.popupOpenedClass);
                            });
                        }

                        const popupWindowCloses = popupWindowCurrent.querySelectorAll(this.options.popupClose);
                        if (popupWindowCloses) {
                            popupWindowCloses.forEach((popupWindowCurrentClose) => {
                                popupWindowCurrentClose.addEventListener('click', (event) => {
                                    popupTriggerCurrent.classList.remove(this.options.dropboxOpenedClass);
                                    popupWindowCurrent.classList.remove(this.options.popupOpenedClass);
                                });
                            });
                        }
                    }

                    event.stopPropagation(); // Stops the event from propagating to the parent
                    event.preventDefault();
                });
            });
        }

    }

    setPosition(trigger, popupWindow) {
        if (popupWindow.getAttribute('data-popup-positioner') !== 'none') {


            popupWindow.classList.add(this.options.popupPreopenedClass);

            const triggerRect = trigger.getBoundingClientRect();
            // const triggerRect2 = this.cumulativeOffset(trigger);
            const popupRect = popupWindow.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            // console.log(triggerRect, popupRect, viewportWidth, viewportHeight);

            const margin = this.options.margin;
            const offset = this.options.offset;

            // Default positions: below the trigger
            let top = triggerRect.bottom + offset;
            let left = triggerRect.left;
            let right = triggerRect.right;

            // Check if it fits below
            // if (top + popupRect.height > viewportHeight - margin) {
            //     // Try placing above
            //     top = triggerRect.top - popupRect.height - offset;
            //     if (top < margin) {
            //         // If above doesn't fit, try left or right
            //         top = triggerRect.top;
            //         left = triggerRect.left - popupRect.width - offset; // Try left
            //
            //         if (left < margin) {
            //             left = triggerRect.right + offset; // If left doesn't fit, try right
            //
            //             if (left + popupRect.width > viewportWidth - margin) {
            //                 // If right doesn't fit, fallback to bottom
            //                 left = triggerRect.left;
            //                 top = viewportHeight - popupRect.height - margin;
            //             }
            //         }
            //     }
            // }

            if (popupWindow.getAttribute('data-popup-positioner') === 'center') {
                popupRect.width = 243;
                left = triggerRect.left - triggerRect.width / 2 - popupRect.width / 2;
            }

            // Adjust horizontal alignment
            if (left + popupRect.width > viewportWidth - margin) {
                left = viewportWidth - popupRect.width - margin;
            }

            if (left < margin) {
                left = margin; // Ensure minimum margin
            }


            if (popupWindow.getAttribute('data-popup-positioner') === 'center') {
                popupWindow.style.position = 'absolute';

                popupWindow.style.top = `${top}px`;
                popupWindow.style.left = `${left}px`;
                popupWindow.style.right = `auto`;
            } else if (popupWindow.getAttribute('data-popup-positioner') === 'right') {

                // popupWindow.style.transform-origin: "top right";
                popupWindow.style.position = 'absolute';

                popupWindow.style.top = `${top}px`;
                popupWindow.style.left = `auto`;
                popupWindow.style.right = `calc(100% - ${right}px)`;
            } else if (viewportWidth > 769) {
                popupWindow.style.position = 'absolute';

                popupWindow.style.top = `${top}px`;
                popupWindow.style.left = `${left}px`;
                popupWindow.style.right = `auto`;

                if (viewportWidth < 1201) {
                    popupWindow.style.left = `auto`;
                    popupWindow.style.right = `calc(100% - ${right}px)`;
                }
            }
            popupWindow.classList.add(this.options.popupOpenedClass);
            popupWindow.classList.remove(this.options.popupPreopenedClass);
        } else popupWindow.classList.add(this.options.popupOpenedClass);

    }
}


// cumulativeOffset(element) {
//     let top = 0, left = 0;
//     do {
//         top += element.offsetTop  || 0;
//         left += element.offsetLeft || 0;
//         top += parseInt(window.getComputedStyle(element).paddingTop, 10) || 0;
//         left += parseInt(window.getComputedStyle(element).paddingLeft, 10) || 0;
//
//         console.log(element.offsetParent);
//         console.log(element.offsetLeft);
//         element = element.offsetParent;
//     } while(element);
//     return {
//         top: top,
//         left: left
//     };
// };


onDomReady(() => {
    const popup = new Popup();
}, false);